const defaults = require('./defaults');

const { elastic } = defaults;

module.exports = {
  ...defaults,
  mode: 'production',
  sourceMap: 'source-map',
  cacheControl: 'max-age=600',
  urlRoot: 'https://www.localsearch.com.au',
  apiRoot: 'https://daapi.lsapis.com.au',
  serviceApiRoot: 'https://services.lsapis.com.au',
  serviceGraphqlRoot: 'https://services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://images.localsearch.com.au',
  addABusinessRoot: 'https://forbusiness.localsearch.com.au/create-profile',
  filemakerApiRoot:
    'https://03y6jplc7a.execute-api.ap-southeast-2.amazonaws.com/production',
  recaptchaRoot:
    'https://snt1hsxm54.execute-api.ap-southeast-2.amazonaws.com/production',
  recaptchaMinScore: 0.5,
  gtmId: 'GTM-TZTSNVJ',
  token: {
    ...defaults.token,
    cookie: {
      domain: '.localsearch.com.au',
    },
  },
  bpm: {
    baseUrl: 'https://forbusiness.localsearch.com.au',
  },
  auth: {
    ...defaults.auth,
    domain: 'auth.localsearch.com.au',
    audience: 'https://services.lsapis.com.au',
    redirectUri: 'https://www.localsearch.com.au/login-loader',
    returnTo: 'https://www.localsearch.com.au',
    clientID: 'ijkpfq4N4I23hUYvqQ0Ol0qyeCTyH5Q0',
  },
  elastic: {
    ...elastic,
    node: 'https://es8.elasticsearch-prod.localsearch.cloud',
    cacheControl: 'max-age=600',
  },
  v2UrlRoot: 'https://www.localsearch.com.au',
  deploy: {
    vpcSubnetIds: ['subnet-14fe6173', 'subnet-c2129b8b'],
    vpcSecurityGroupIds: ['sg-01e194158f2ed4023', 'sg-87e953fe'],
  },
  optimizelyUrl: 'https://cdn.optimizely.com/js/26419890619.js',
};
